<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="兴趣标签名称" prop="tagName">
                <a-input v-model="queryParam.tagName" placeholder="请输入兴趣标签名称" allow-clear/>
              </a-form-item>
            </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="话题名称" prop="title">
                  <a-input v-model="queryParam.title" placeholder="请输入话题名称" allow-clear/>
                </a-form-item>
              </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >

        <img style="width: 48px;height: 48px;" preview="封面" :src="record.cover" v-if="record.cover != null && record.cover != ''" slot="cover" slot-scope="text, record">

        <img style="width: 48px;height: 48px;" preview="背景图" :src="record.background" v-if="record.background != null && record.background != ''" slot="background" slot-scope="text, record">

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" >
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" >
            <a-icon type="delete" />删除
          </a>
           <a-divider type="vertical"/>
          <a-popconfirm v-if="record.isHot == 0" title="是否确认设为热门" @confirm="() => setIsHot(record.id,1)">
            <a>设为热门</a>
          </a-popconfirm>
          <a-popconfirm v-if="record.isHot == 1" title="是否确认取消热门" @confirm="() => setIsHot(record.id,0)">
            <a>取消热门</a>
          </a-popconfirm>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageVideoTopic,delVideoTopic } from '@/api/platform/videoTopic'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import request from "@/utils/request";

export default {
  name: 'VideoTopic',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        tagId: null,
        cover: null,
        background: null,
        title: null,
        intro: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '话题名称',
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '封面',
          dataIndex: 'cover',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: "cover"}
        },
        {
          title: '背景图',
          dataIndex: 'background',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: "background"}
        },
        {
          title: '兴趣标签名称',
          dataIndex: 'tagName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否热门',
          dataIndex: 'isHot',
          ellipsis: true,
          align: 'center',
          customRender: function (value) {
            if (value == 0){
              return "否"
            }
            if (value == 1){
              return "是"
            }
          }
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询视频-话题列表 */
    getList () {
      this.loading = true
     pageVideoTopic(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    setIsHot(id,isHot){
      var that = this;
      let param = {"id":id,"isHot":isHot};
      request({
        url: '/platform/video-topic/isHot',
        method: 'post',
        params: param
      }).then((res)=>{
        if (res.success) {
          that.$message.success(res.message);
          that.getList()
        } else {
          that.$message.warning(res.message);
        }
        that.getList()
      });
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        tagId: undefined,
        cover: undefined,
        background: undefined,
        title: undefined,
        intro: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delVideoTopic(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('platform/video-topic/export', {
            ...that.queryParam
          }, `视频-话题_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
